import { Injectable } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';
import { Confirm } from './confirm';
import { LoggerService } from '../../shared/logger/logger.service';

/**
 * This service is used to display confirm dialogs when requested.
 */
@Injectable()
export class ConfirmService {

  /**
   * Rxjs Subject for Confirm actions
   * @type {Subject<Confirm>}
   */
  private requireConfirmSource = new Subject<Confirm>();

  /**
   * Rxjs Observable for requireConfirmSubject
   * @type {Observable<Confirm>}
   */
  requireConfirm$: Observable<Confirm> = this.requireConfirmSource.asObservable();

  /**
   * Default constructor
   * @param {LoggerService} logger
   */
  constructor(private logger: LoggerService) {
    this.logger.info('ConfirmService constructed.');
  }

  /**
   * Add new Confirm event to requireConfirmSource, thus requesting new ConfirmModal.
   * @param {Confirm} confirm
   * @returns {ConfirmService}
   */
  public confirm(confirm: Confirm) {
    this.requireConfirmSource.next(confirm);
    return this;
  }
}
